import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import worldGif from "./world.gif";

export default function Home() {
  const navigate = useNavigate();

  const go = useCallback(
    (path) => {
      navigate(path);
    },
    [navigate]
  );

  useEffect(() => {
    const onKeyDown = (e) => {
      const tag = e.target?.tagName?.toLowerCase?.() || "";
      if (tag === "input" || tag === "textarea" || e.target?.isContentEditable) return;

      if (e.key === "1") go("/portfolio");
      if (e.key === "2") go("/about");
      if (e.key === "3") go("/contact");
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [go]);

  return (
    <div className="homePage">
      <section className="homePanel">
        <div className="homeInner">
          <div className="homeHero">
            <div className="homeHeroLeft">
              {/* keep your original glitch styling from your global css */}
              <h1 className="homeTitle glitch" data-text="Hello World!">
                Hello World!
              </h1>

                <div className="homeKeyHint">
                <span className="homePress">Shortcut:</span>{" "}
                press{" "}
                <span className="chip homeKeyChip">1</span>
                <span className="homeKeyDash">–</span>
                <span className="chip homeKeyChip">3</span>{" "}
                to open a page.
                </div>


            </div>

            <div className="homeHeroRight">
              <div className="homeOrb" aria-hidden="true">
                <img className="homeOrbImg" src={worldGif} alt="" />
              </div>
            </div>
          </div>

          <div className="homeDivider" />

          <div className="homeNavGrid">
            <button className="homeNavCard" onClick={() => go("/portfolio")}>
              <div className="homeNavRow">
                <div className="homeNavTitle">Portfolio</div>
                <div className="homeNavMeta">
                  <span className="chip homeNavChip">1</span>
                  <span className="homeNavArrow">›</span>
                </div>
              </div>
            </button>

            <button className="homeNavCard" onClick={() => go("/about")}>
              <div className="homeNavRow">
                <div className="homeNavTitle">About</div>
                <div className="homeNavMeta">
                  <span className="chip homeNavChip">2</span>
                  <span className="homeNavArrow">›</span>
                </div>
              </div>
            </button>

            <button className="homeNavCard" onClick={() => go("/contact")}>
              <div className="homeNavRow">
                <div className="homeNavTitle">Contact</div>
                <div className="homeNavMeta">
                  <span className="chip homeNavChip">3</span>
                  <span className="homeNavArrow">›</span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
